import sliceCreator from '../../index.jsx';
import {CREATE_SEASON} from '../../../constants/index.jsx';
const _createSeasonAction = sliceCreator('CREATE_SEASON', CREATE_SEASON, 'post');

const { asyncAction: createSeasonAction, reducer, clearData: clearCreateSeasonAction } = _createSeasonAction;

export default reducer;

export {
    createSeasonAction,
    clearCreateSeasonAction
}